<template>
  <v-timeline-item color="grey" icon="remove" small>
    <v-layout pt-3>
      <v-flex xs2>
        <strong>{{ termination.created }}</strong>
      </v-flex>
      <v-flex xs10>
        <strong>Solicitud de finalización por {{ termination.type.toLowerCase() }} </strong>
        <a v-if="termination.asset !== null" :href="termination.asset.url" target="_blank" class="addenda-link ml-2">
          Visualizar
          <v-tooltip bottom>
            <v-icon small slot="activator" color="primary">open_in_new</v-icon>
            <span>Visualizar adjunto</span>
          </v-tooltip>
        </a>
        <div class="text-formatted">{{ termination.description }}</div>
        <div class="text-formatted" v-if="termination.clubLpfDestino">Transferencia a Club: {{ termination.clubLpfDestino.nombre }}</div>
        <div class="text-formatted" v-if="termination.clubTo">Transferencia a Club: {{ termination.clubTo }}</div>
      </v-flex>
    </v-layout>
  </v-timeline-item>
</template>

<script>
export default {
  props: {
    termination: Object
  }
}
</script>

<style scoped>
  .addenda-link {
    text-decoration: none !important;
  }
</style>
